module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_j_albino.90c1e9d3.png";